<img src="{{icon}}" alt="{{data}}" width="50" >
<p class="pt-3">
    <a href="{{link}}">
        {{data}}
    </a>
</p>
